const normalizeBaseUrl = (url = '') => url.replace(/\/+$/, '')

const appConfig = {
    apiPrefix: normalizeBaseUrl(process.env.REACT_APP_API_URL || ''),
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export { normalizeBaseUrl }

export default appConfig
